import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, shadow, fontSize } = theme.tokens;
  return {
    card: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 10,
      padding: "16px 12px",
      borderRadius: radius.card,
      boxShadow: shadow.hairline,
      backgroundColor: color.bg,
      color: color.ink,
      textDecoration: "none",
      "&:hover": { boxShadow: shadow.hairlineHover, color: color.ink }
    },
    logo: {
      width: 88,
      height: 88,
      borderRadius: radius.pill,
      backgroundColor: color.surface,
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    logoImg: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "transform .25s ease"
    },
    name: {
      fontSize: fontSize.body,
      fontWeight: 700,
      textAlign: "center",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "100%"
    },
    // hover effects go last: JSS resolves $refs only to classes defined above
    [theme.media.hover]: {
      card: { "&:hover $logoImg": { transform: "scale(1.06)" } }
    }
  };
});

export default withCustomStyles;
